module.exports = __webpack_public_path__ + "img/privateIcon.b7872ac1.png";